import {Action} from "../actions/tocForPagesActions";
import {ActionType} from "../actionTypes";
import {ErrorDto, FlyerPagesTocEntriesDto} from "../../dtos";

const initialState = {
    tocForPage: null,
    loading: false,
    error: null,
    type: null
}

interface initialStateDto {
    tocForPage: FlyerPagesTocEntriesDto | null,
    loading: boolean,
    error: ErrorDto | null,
    type: string | null

}

export const tocForPagesReducer = (state: initialStateDto = initialState, action: Action): initialStateDto => {
    switch (action.type) {

        // create toc for page
        case ActionType.CREATE_TOC_FOR_PAGE_START:
            return { tocForPage: null, type: action.type, error: null, loading: true }

        case ActionType.CREATE_TOC_FOR_PAGE_SUCCESS:
            return { ...state, type: action.type, tocForPage: action.payload, error: null, loading: false }

        case ActionType.CREATE_TOC_FOR_PAGE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false }

        case ActionType.CREATE_TOC_FOR_PAGE_COMPLETE:
            return { ...state, type: action.type, error: null, loading: false }

        // update toc for page
        case ActionType.UPDATE_TOC_FOR_PAGE_START:
            return { tocForPage: null, type: action.type, error: null, loading: true }

        case ActionType.UPDATE_TOC_FOR_PAGE_SUCCESS:
            return { ...state, type: action.type, tocForPage: action.payload, error: null, loading: false }

        case ActionType.UPDATE_TOC_FOR_PAGE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false }

        case ActionType.UPDATE_TOC_FOR_PAGE_COMPLETE:
            return { ...state, type: action.type, error: null, loading: false }

        // delete toc for page
        case ActionType.DELETE_TOC_FOR_PAGE_START:
            return { tocForPage: null, type: action.type, error: null, loading: true }

        case ActionType.DELETE_TOC_FOR_PAGE_SUCCESS:
            return { ...state, type: action.type, tocForPage: action.payload, error: null, loading: false }

        case ActionType.DELETE_TOC_FOR_PAGE_ERROR:
            return { ...state, type: action.type, error: action.payload, loading: false }

        case ActionType.DELETE_TOC_FOR_PAGE_COMPLETE:
            return { ...state, type: action.type, error: null, loading: false }

        default:
            return state;
    }

}